import {useContext} from 'react';

import {PopupContext} from './PopupProvider';

export function usePopup() {
  const value = useContext(PopupContext);

  return value;
}
